import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-managed-user-comment',
  templateUrl: './managed-user-comment.component.html',
  styleUrls: ['./managed-user-comment.component.scss']
})
export class ManagedUserCommentComponent extends BaseComponent implements OnInit {

  @Input() userText : string = "";
  @Input() isDisabled : boolean = false;
  @Output() userTextChange : EventEmitter<string> = new EventEmitter<string>();
  @Output() submitTextEvent = new EventEmitter<string>();

  inEditMode : boolean = false;
  buttonIconName: string = "";

  constructor() {
    super();
   }

  ngOnInit(): void {
    super.ngOnInit();

    this.invalidateInteraction();
  }

  ngOnChanges (changes: SimpleChanges){

    if (!(changes.userText && changes.isDisabled)){
      return;
    }

    if ((!changes.userText.firstChange && changes.userText.currentValue != changes.userText.previousValue) ||
        (!changes.isDisabled.firstChange && changes.isDisabled.currentValue != changes.isDisabled.previousValue)){
          this.invalidateInteraction();
        }
  }

  invalidateInteraction(){
    this.inEditMode = false;
    if (!this.isDisabled && this.userText == ""){
      this.inEditMode = true;
    }

    this.calcButtonIcon();
  }

  calcButtonIcon(): void{
    if (this.inEditMode){
      if (this.isRTL){
        this.buttonIconName = "send";
      }
      else{
        this.buttonIconName = "send";
      }
      
    }
    else{
      this.buttonIconName = "edit";
    }
  }

  actionButtonClicked(): void{
    if (this.inEditMode){
      this.inEditMode = false;
      this.userTextChange.emit(this.userText);
      this.submitTextEvent.emit(this.userText);
    }
    else{
      this.inEditMode = true;
    }

    this.calcButtonIcon();
  }
}
